import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck, Mail, ArrowRight, KeyRound, Copy } from "lucide-react";

export const RegistrationSuccessPage = () => {
  const [regInfo, setRegInfo] = useState(null);

  useEffect(() => {
    const raw = sessionStorage.getItem("kt_last_reg");
    if (raw) {
      try {
        setRegInfo(JSON.parse(raw));
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-background py-16 px-4 flex items-center justify-center">
      <div className="max-w-md w-full bg-card border border-border rounded-2xl p-8 shadow-xl text-center space-y-6">
        <div className="w-16 h-16 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 mx-auto flex items-center justify-center">
          <CheckCircle2 className="w-9 h-9" />
        </div>

        <div className="space-y-2">
          <span className="text-[11px] font-mono uppercase px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">
            Application Status: Pending Review
          </span>
          <h1 className="text-2xl font-bold tracking-tight">Registration Submitted</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Your application has been submitted successfully. Our team will verify your details. You will receive further instructions on your registered email address.
          </p>
        </div>

        {regInfo?.applicationNumber && (
          <div className="p-4 rounded-xl bg-muted/50 border border-border text-left font-mono text-xs space-y-2">
            <div className="flex justify-between items-center border-b border-border pb-1.5">
              <span className="text-muted-foreground">Application Ref:</span>
              <span className="font-bold text-emerald-400">{regInfo.applicationNumber}</span>
            </div>
            {regInfo.fullName && (
              <div className="flex justify-between items-center">
                <span className="text-muted-foreground">Applicant:</span>
                <span className="text-foreground">{regInfo.fullName}</span>
              </div>
            )}
            {regInfo.email && (
              <div className="flex justify-between items-center">
                <span className="text-muted-foreground">Registered Email:</span>
                <span className="text-foreground truncate max-w-[200px]">{regInfo.email}</span>
              </div>
            )}
          </div>
        )}

        <div className="p-3.5 rounded-lg bg-cyan-500/10 border border-cyan-500/20 text-cyan-300 text-xs text-left flex items-start gap-2.5">
          <Mail className="w-4 h-4 flex-shrink-0 mt-0.5 text-cyan-400" />
          <span>
            Upon verification by Kian Technologies admin staff, your unique Student ID (e.g.{" "}
            <code className="font-mono text-cyan-200">KIAN-CYBER-XXXX</code>) and password activation link will be sent to your email.
          </span>
        </div>

        <div className="pt-2 flex flex-col gap-2">
          <Link
            to="/"
            data-testid="success-home-btn"
            className="w-full py-2.5 px-4 rounded-lg border border-border bg-card hover:bg-muted text-foreground text-xs font-mono font-medium transition-colors"
          >
            Return to Masterclass Home
          </Link>
          <Link
            to="/login"
            data-testid="success-login-btn"
            className="w-full py-2.5 px-4 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-mono font-medium transition-colors flex items-center justify-center gap-1.5"
          >
            <span>Student Login</span>
            <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    </div>
  );
};
